import { Mention } from "@portal/BaseComponents/Mentions/AntMentions";
import { CommentDefaultFormElementProps } from "./type";
const t = {
  placeholder: "Add Comment...",
};
function CommentForm(props: CommentDefaultFormElementProps<string, string>) {
  const { value, onChange, placeholder = t.placeholder } = props;
  return (
    <Mention
      defaultValue={value}
      rows={4}
      onChange={onChange}
      placeholder={placeholder}
      style={{ width: "100%" }}
    />
  );
}

export { CommentForm };
